import React from "react";
import { Routes, Route } from "react-router-dom"; 
import Navigation from "./components/Navigation"; 
import Home from "./components/Home";
import Collection from "./components/Collection"; 
import Cart from "./components/Cart"
import Checkout from "./components/Checkout"
import Contact from "./components/Contact"
import { CartProvider } from "./context/CartContext";

const App = () => {
  return (
    <CartProvider>
      <Navigation /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/collection" element={<Collection />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </CartProvider>
  );
};

export default App;
